import PropTypes from 'prop-types';
import './ServiceAccordion.scss';

const LeftContentServiceAccordion = ({ title, state }) => (
  <div className="left-content-service-accordion">
    <div
      style={{
        backgroundColor: `${state === 'incomplete' ? '#EFEFEF' : '#4AD295'}`
      }}
    />
    <b>{title}</b>
  </div>
);

LeftContentServiceAccordion.propTypes = {
  title: PropTypes.string,
  state: PropTypes.string.isRequired
};

LeftContentServiceAccordion.defaultProps = {
  title: 'Datos del servicio'
};

export default LeftContentServiceAccordion;
